export default __webpack_public_path__ + "./fonts/assignment_returned.970db316.svg";